/**
 * @generated SignedSource<<94b1cf965e9b370635cea16383fdeb8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PlayerList_Booking$data = {
  readonly " $fragmentSpreads": FragmentRefs<"OtherPlayersInThisBooking_Booking">;
  readonly " $fragmentType": "PlayerList_Booking";
};
export type PlayerList_Booking$key = {
  readonly " $data"?: PlayerList_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlayerList_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PlayerList_Booking",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OtherPlayersInThisBooking_Booking"
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "81d51c1cb299e312197b4351a586e1b5";

export default node;
